import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "../lib/smooth";

export const Logo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <a
      href="/"
      data-testid="brand-logo"
      onClick={(e) => {
        e.preventDefault();
        if (location.pathname === "/") {
          scrollToSection(0);
        } else {
          navigate("/", { state: { scrollTo: "#top" } });
        }
      }}
      className="group flex items-center gap-3 cursor-pointer"
    >
      <img
        src="/logo.png"
        alt="Future Factory Group logo"
        className="h-9 w-auto transition-transform duration-300 group-hover:scale-105"
      />
      <div className="leading-none">
        <span className="block font-display text-[11px] font-semibold tracking-[0.22em] text-white">
          FUTURE FACTORY
        </span>
        <span className="mt-1 block font-mono text-[9px] tracking-[0.42em] text-neon">
          GROUP
        </span>
      </div>
    </a>
  );
};

export default Logo;
